import { lazy } from "react";
import { ROUTES } from "../constants";

const Onboarding = lazy(() => import("../screens/Onboarding"));
const Register = lazy(() => import("../screens/Register"));
const VerifyOTP = lazy(() => import("../screens/VerifyOTP"));
const VerifyPIN = lazy(() => import("../screens/VerifyPIN"));
const AccountInformation = lazy(() => import("../screens/AccountInformation"));
const Language = lazy(() => import("../screens/Language"));
const FAQ = lazy(() => import("../screens/FAQ"));
const Settings = lazy(() => import("../screens/Settings"));
const CompanyDetatils = lazy(() => import("../screens/CompanyDetails"));
const ContactUs = lazy(() => import("../screens/ContactUs"));
const TermsAndConditions = lazy(() => import("../screens/TermsAndConditions"));
const FinanceDetail = lazy(() => import("../screens/FinanceDetail"));
const MerchantSupport = lazy(() => import("../screens/MerchantSupport"));
const Payments = lazy(() => import("../screens/Payments"));
const CompletedPayments = lazy(() => import("../screens/CompletedPayments"));

const AcceptTermsAndConditions = lazy(
  () => import("../screens/AcceptTermsAndConditions")
);
const WathqInformation = lazy(() => import("../screens/WathqInformation"));
const NafathVerification = lazy(() => import("../screens/NafathVerification"));
const CheckEligibility = lazy(() => import("../screens/CheckEligibility"));
const LoginScreen = lazy(() => import("../screens/Login"));
const PrivacyPolicy = lazy(() => import("../screens/PrivacyPolicy"));
const RepaymentSchedule = lazy(() => import("../screens/RepaymentSchedule"));

export const appRoutes = (tenantConfig) => {
  return [
    {
      path: `/`,
      exact: true,
      key: ROUTES.LOGIN,
      component: LoginScreen,
    },
    {
      path: `/${ROUTES.CHECK_ELIGIBILITY}`,
      exact: true,
      key: ROUTES.CHECK_ELIGIBILITY,
      component: CheckEligibility,
    },
    {
      path: `/${ROUTES.PARTNER_JOURNEY}`,
      exact: true,
      key: ROUTES.PARTNER_JOURNEY,
      component: CompanyDetatils,
    },
    {
      path: `/${ROUTES.VERIFY_OTP}`,
      exact: true,
      key: ROUTES.VERIFY_OTP,
      component: VerifyOTP,
    },
    {
      path: `/${ROUTES.VERIFY_PIN}`,
      exact: true,
      key: ROUTES.VERIFY_PIN,
      component: VerifyPIN,
    },
    {
      path: `/${ROUTES.FAQ}`,
      exact: true,
      key: ROUTES.FAQ,
      component: FAQ,
      isProtected: true,
    },
    {
      path: `/${ROUTES.SETTINGS}`,
      exact: true,
      key: ROUTES.SETTINGS,
      component: Settings,
      isProtected: true,
    },
    {
      path: `/${ROUTES.PROFILE_DETAILS}`,
      exact: true,
      key: ROUTES.PROFILE_DETAILS,
      component: AccountInformation,
      isProtected: true,
    },
    {
      path: `/${ROUTES.LANGUAGE}`,
      exact: true,
      key: ROUTES.LANGUAGE,
      component: Language,
      isProtected: true,
    },
    {
      path: `/${ROUTES.CONTACT_US}`,
      exact: true,
      key: ROUTES.CONTACT_US,
      component: ContactUs,
      isProtected: true,
    },
    {
      path: `/${ROUTES.COMPANY_DETAILS}`,
      exact: true,
      key: ROUTES.COMPANY_DETAILS,
      component: CompanyDetatils,
      // isProtected: true,
    },
    {
      path: `/${ROUTES.TERMS_AND_CONDITIONS}`,
      exact: true,
      key: ROUTES.TERMS_AND_CONDITIONS,
      component: TermsAndConditions,
    },
    {
      path: `/${ROUTES.PRIVACY_POLICY}`,
      exact: true,
      key: ROUTES.PRIVACY_POLICY,
      component: PrivacyPolicy,
    },
    {
      path: `/${ROUTES.MERCHANT_SUPPORT}`,
      exact: true,
      key: ROUTES.MERCHANT_SUPPORT,
      component: MerchantSupport,
      isProtected: true,
    },
    {
      path: `/${ROUTES.FINANCE_DETAIL}`,
      exact: true,
      key: ROUTES.FINANCE_DETAIL,
      component: FinanceDetail,
      isProtected: true,
    },
    {
      path: `/${ROUTES.PAYMENTS}`,
      exact: true,
      key: ROUTES.PAYMENTS,
      component: Payments,
      isProtected: true,
    },
    {
      path: `/${ROUTES.COMPLETED_PAYMENTS}`,
      exact: true,
      key: ROUTES.COMPLETED_PAYMENTS,
      component: CompletedPayments,
      isProtected: true,
    },
    {
      path: `/${ROUTES.ACCEPT_TERMS_AND_CONDITION}`,
      exact: true,
      key: ROUTES.ACCEPT_TERMS_AND_CONDITION,
      component: AcceptTermsAndConditions,
    },
    {
      path: `/${ROUTES.NAFATH_VERIFICATION}`,
      exact: true,
      key: ROUTES.NAFATH_VERIFICATION,
      component: NafathVerification,
    },
    {
      path: `/${ROUTES.WATHQ_VERIFICATION}`,
      exact: true,
      key: ROUTES.WATHQ_VERIFICATION,
      component: WathqInformation,
    },
    {
      path: `/${ROUTES.REPAYMENT_SCHEDULE}`,
      exact: true,
      key: ROUTES.REPAYMENT_SCHEDULE,
      component: RepaymentSchedule,
    },
  ];
};

export const onboardingRoutes = () => {
  return [
    {
      path: `/`,
      exact: true,
      key: ROUTES.ONBOARDING,
      component: Onboarding,
    },
    {
      path: `/${ROUTES.CHECK_ELIGIBILITY}`,
      exact: true,
      key: ROUTES.CHECK_ELIGIBILITY,
      component: CheckEligibility,
    },
  ];
};
